import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { uploads } from "../../../utils/config";
import Input from '../../../components/elements/Input';
import Select from '../../../components/elements/Select';
import Title2 from '../../../components/elements/Title2';
import Button from '../../../components/elements/Button';
import ChallengeList from './ChallengeList';
import { motion } from 'framer-motion';
import { resetMessage, addChallenge } from "../../../slices/challengeSlice";


const AddChallenge = () => {
  const dispatch = useDispatch();
  const { challenge, message, error, loading } = useSelector((state) => state.challenge);
  const [showMessageSuccess, setShowMessageSuccess] = useState(false);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [difficulty, setDifficulty] = useState('');
  const [openDate, setOpenDate] = useState('');
  const [answer, setAnswer] = useState('');
  const [phase, setPhase] = useState('');
  const [block, setBlock] = useState('');
  const [challengeImage, setChallengeImage] = useState(null);
  const [previewImage, setPreviewImage] = useState("");
  const [refreshKey, setRefreshKey] = useState(0);

  const toggleVisibility = () => {
    if(!error){
      setShowMessageSuccess(true);
    }
  }

  const phases = [
    { label: 'Fase 1', value: '1' },
    { label: 'Fase 2', value: '2' },
    { label: 'Fase 3', value: '3' },
    { label: 'Fase 4', value: '4' },
    { label: 'Fase 5', value: '5' },
    { label: 'Fase 6', value: '6' },
    { label: 'Fase 7', value: '7' },
    { label: 'Fase 8', value: '8' },
    { label: 'Fase 9', value: '9' },
    { label: 'Fase 10', value: '10' },
    { label: 'Fase 11', value: '11' },
    { label: 'Fase 12', value: '12' },
    { label: 'Fase 13', value: '13' },
    { label: 'Fase 14', value: '14' },
    { label: 'Fase 15', value: '15' },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setRefreshKey((oldKey) => oldKey + 1);
    const challengeData = {
      title,
      description,
      difficulty,
      openDate,
      answer,
      challengeImage,
      phase,
      block
    }

    const formData = new FormData();
    
    for (const key in challengeData) {
      if (challengeData[key]) { // Verifica se o valor não é nulo ou indefinido
        formData.append(key, challengeData[key]);
      }
    }

    await dispatch(addChallenge(formData));
    setRefreshKey((oldKey) => oldKey + 1);

    setTimeout(() => {
      dispatch(resetMessage());
    }, 2000);

  }

  const handleFile = (e) => {
    const image = e.target.files[0];
    setChallengeImage(image); // Armazena o arquivo no estado do componente pai
    setPreviewImage(image);
  }

  return (
    <>
      <motion.div
        className="basis-1/4 bg-verde-oliva border-verde-musgo bg-opacity-85 sm:rounded-lg content-center border-solid shadow-md rounded p-3 m-3 min-w-96 text-left"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <Title2 tit={"Adicionar Desafio"} model="wr"/>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="font-roboto block mb-2 text-sm font-bold text-gray-900 dark:text-white"></label>
            <input name="challengeImage" onChange={handleFile} className="text-xl font-special bg-dour-suave border border-dour-suave text-bordo-700 text-sm rounded-full focus:ring-cinza-cl focus:border-cinza-cl-500 block w-full p-2.5" type="file"/>
          </div>
          <Input
            placeholder="Título"
            onChange={setTitle}
            label={"Título do desafio"}
            font="font-roboto"
          />
          <Input
          placeholder="Descrição"
            onChange={setDescription}
            label={"Descrição do desafio"}
            font="font-roboto"
          />
          <Input
            placeholder="Dificuldade"
            onChange={setDifficulty}
            label={"Dificuldade do desafio"}
            font="font-roboto"
          />
          <Input
            placeholder="Data de abertura"
            onChange={setOpenDate}
            label={"Libera em"}
            font="font-roboto"
          />
          <Input
            placeholder="Resposta"
            onChange={setAnswer}
            label={"Resposta do desafio"}
            font="font-roboto"
          />
          <Input
            placeholder="Bloco X"
            onChange={setBlock}
            label={"Número do bloco"}
            font="font-roboto"
          />
          <Select
            className="bg-dour-suave border border-dour-suave text-bordo-700 text-sm rounded-full focus:ring-cinza-cl focus:border-cinza-cl block w-full p-2.5"
            value={phase}
            options={phases}
            onChange={setPhase} />

          {!loading && <input onClick={toggleVisibility} type="submit" className="font-special font-semibold  transition ease-in-out delay-150 duration-300 hover:-translate-y-1 hover:scale-110 text-white bg-bordo hover:bg-bordo-600 focus:outline-none focus:ring-bege-cl-300 font-medium rounded-full text-sm w-full sm:w-40 px-5 py-2.5 text-center" value="Criar" />}
          {loading && <Button propertiesButton={{type: "submit", dis: "disabled", desc: "Aguarde..."}}/>}
        </form>
      </motion.div>
      <motion.div
        className="basis-1/4 bg-verde-oliva border-verde-musgo bg-opacity-85 sm:rounded-lg content-center border-solid shadow-md rounded p-3 m-3 min-w-96"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <Title2 tit={"Previsualização"} model="wr"/>
        {(challengeImage || previewImage) && (
          <img className="" src={
            previewImage
              ? URL.createObjectURL(previewImage)
              : `${uploads}/users/${challenge.challengeImage}`
          } alt={title} />
        )}
      </motion.div>
      <motion.div
        className="basis-1/2 bg-cinza-cl border-verde-musgo bg-opacity-85 sm:rounded-lg border-solid shadow-md rounded p-3 m-3 min-w-96"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <motion.div
          className="items-start justify-center place-items-stretch"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
        <Title2 tit={"Desafios criados"} model="br"/>
          <ChallengeList refr={refreshKey} />
        </motion.div>
      </motion.div>
    </>
  );

}

export default AddChallenge